import { Inset, Spacing } from '@doordash/design-language';
export var ARROW_SIZE = 6;
export var SPACING_FROM_NEAREST_CORNER = Spacing.XSmall;
export var SPACING_FROM_ANCHOR = Spacing.XxSmall;
export var InteractionTypes = {
  Hover: 'HOVER',
  Focus: 'FOCUS',
  Click: 'CLICK',
  ToggleHover: 'TOGGLE_HOVER',
  ToggleFocus: 'TOGGLE_FOCUS',
  ToggleClick: 'TOGGLE_CLICK',
  Controlled: 'CONTROLLED'
};
export var ContentWrapperDisplayModes = {
  Flex: 'flex',
  InlineFlex: 'inline-flex',
  InlineBlock: 'inline-block',
  Block: 'block',
  Inline: 'inline'
};
export var Sizes = {
  Small: Inset.Sizes.XxSmall,
  Large: Inset.Sizes.Small
};
export var Types = {
  Informational: 'Informational',
  Highlight: 'Highlight'
};